import React from 'react';

import { RouteComponentProps } from '@reach/router';

import { isMobile } from 'react-device-detect';
import { EventWizardNavigatorMobile } from './EventWizardNavigatorMobile';
import { EventWizardNavigatorDesktop } from './EventWizardNavigatorDesktop';

export const BASE_TAB_WIDTH = 140;

export const tabsToScroll = () =>
  Math.floor(Math.min(window.innerWidth - 100, window.innerWidth * 0.85) / BASE_TAB_WIDTH);

export interface IEventWizardNavigator extends RouteComponentProps {
  currentPage: string;
  currentRound: number;
}

export const EventWizardNavigator = (props: IEventWizardNavigator) => {
  return isMobile ? <EventWizardNavigatorMobile /> : <EventWizardNavigatorDesktop {...props} />;
};
